import { Observable } from 'rxjs';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

/**
 * Adds a short Accept-Language header to all main API requests.
 * The backend stores locale from this header; the browser's default
 * Accept-Language (e.g. "hu-HU,hu;q=0.9,en-US;q=0.8") is too long
 * for the locale column and causes a DB truncation error.
 */
@Injectable()
export class LocaleInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!request.url.startsWith(environment.baseUrl) || request.url.startsWith('./assets/i18n/')) {
      return next.handle(request);
    }
    if (request.headers.has('Accept-Language')) {
      return next.handle(request);
    }
    const localeRequest = request.clone({
      setHeaders: { 'Accept-Language': 'hu' }
    });
    return next.handle(localeRequest);
  }
}
